import { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { Card, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody, select, Label, Input, FormGroup, ModalFooter, Row, Col } from "reactstrap"
import Swal from 'sweetalert2'
import { Api } from "../componentes/Api"
import AsignacionModulos from "./Administracion/AsignacionModulos";
import Select from 'react-select';


const modeloUsuario = {
    idUsuario: 0,
    empresaID:0,
    nombre : "",
    correo :"",
    telefono :"",
    idRol :0,
    clave :"",
    dgii :"",
    esActivo: true,
    impresionPuntoVenta: false
}
let D_usuarioID;


const Usuario = () => {

    const [usuario, setUsuario] = useState(modeloUsuario);
    const [pendiente, setPendiente] = useState(true);
    const [usuarios, setUsuarios] = useState([]);
    const [roles, setRoles] = useState([]);
    const [verModal, setVerModal] = useState(false);
    const [ListaEmpr, SetListaEmpr] = useState([]);
    const [Listado1, SetListado1] = useState([]);
    const [busqueda, setbusqueda] = useState("");
    const [verModalModulosA, setverModalModulosA] = useState(false);
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))


    const handleChange = (e) => {

   

        let value;

        if (e.target.name == "idRol") {
            value = e.target.value
        } else if (e.target.name == "esActivo") {
            value = (e.target.value == "true" ? true : false)
        } else if (e.target.name == "impresionPuntoVenta") {
            value = (e.target.value == "true" ? true : false)
        } else {
            value = e.target.value;
        }

        setUsuario({
            ...usuario,
            [e.target.name]: value
        })
    }

    const onChange = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
        var searchData = l.filter((item) => {
            if (
                (item.nombre + item.correo + item.empleadoID)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        setUsuarios(searchData);
    };
    const AsignarModulos = (d) => {
        setUsuario(d)
        D_usuarioID = d.idUsuario
        setverModalModulosA(true)
    }


    const obtenerRoles = async () => {
        let response = await fetch(Api+"rol/Lista");
        if (response.ok) {
            let data = await response.json()
            setRoles(data)
        }
    }

    const obtenerEmpresas = async () => {

        let response = await fetch(Api + "administracion/ListaEmpresas/"+ JSON.parse(user).idUsuario);
        if (response.ok) {
            let data = await response.json()
            SetListaEmpr(data)
        }
    }

    const obtenerUsuarios = async () => {
        let response = await fetch(Api + "usuario/Lista/" + JSON.parse(user).idUsuario);

        if (response.ok) {
            let data = await response.json()
            setUsuarios(data)
            SetListado1(data)
            setPendiente(false)
        }
    }

    useEffect(() => {
        obtenerRoles();
        obtenerUsuarios();
    }, [])

    const columns = [
        {
            name: 'Nombre',
            selector: row => row.nombre,
            sortable: true,
        },
        {
            name: 'Correo',
            selector: row => row.correo,
            sortable: true,
        },
        {
            name: 'Telefono',
            selector: row => row.telefono,
            sortable: true,
        },
        {
            name: 'Rol',
            selector: row => row.idRolNavigation,
            sortable: true,
            cell: row => (row.idRolNavigation.descripcion)
        },
        {
            name: 'Empresa',
            selector: row => row.empresaID,
            sortable: true,
            cell: row => row.empresaID
        },
        {
            name: 'Estado',
            selector: row => row.esActivo,
            sortable: true,
            cell: row => {
                let clase;
                clase = row.esActivo ? "badge badge-info p-2" : "badge badge-danger p-2"
                return (
                    <span className={clase}>{row.esActivo ? "Activo" : "No Activo"}</span>
                )
            }
        },
        {
            name: '',
            cell: row => (
                <>
                    <Button color="warning" size="sm" className="mr-2"
                        onClick={() => AsignarModulos(row)}
                    >
                        <i className="">R</i>
                    </Button>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>

                    <Button color="danger" size="sm"
                        onClick={() => eliminarUsuario(row.idUsuario)}
                    >
                        <i className="fas fa-trash-alt"></i>
                    </Button>
                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    
    const NuevoUsuario = () => {
        obtenerEmpresas();
        setVerModal(!verModal);
        
    }

    const abrirEditarModal = (data) => {
        obtenerEmpresas();
        setUsuario(data);
        setVerModal(!verModal);
        
    }

    const cerrarModal = () => {
        setUsuario(modeloUsuario)
        setVerModal(!verModal);
    }

    const guardarCambios = async () => {

        delete usuario.idRolNavigation;
        
        usuario.empresaID = parseInt(usuario.empresaID);
        let response;
        if (usuario.idUsuario == 0) {
            response = await fetch(Api+ "usuario/Guardar", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(usuario)
            })

        } else {
            response = await fetch(Api + "usuario/Editar", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(usuario)
            })
        }

        if (response.ok) {
            await obtenerUsuarios();
            setUsuario(modeloUsuario)
            setVerModal(!verModal);

        } else {
            alert("error al guardar")
        }

    }

    const eliminarUsuario = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el usuario",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.isConfirmed) {

                const response = fetch("api/usuario/Eliminar/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {

                            obtenerUsuarios();

                            Swal.fire(
                                'Eliminado!',
                                'El usuario fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }


    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Usuarios
                </CardHeader>
                <CardBody>
                    <Row>     <Col md={2}>  <Button color="success" size="sm" onClick={() => NuevoUsuario()}>Nuevo Usuario</Button></Col>
                    <Col md={4}>
                        <Input type="search" name="busqueda" onChange={(e) => onChange(e)} placeholder="Buscar por Nombre o Correo " ></Input>
                    </Col>  </Row> 
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={usuarios}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal >
                <ModalHeader>
                    <a className="btn"  onClick={cerrarModal}>X</a>   Detalle Usuario
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Nombre</Label>
                                <Input bsSize="sm" name="nombre" onChange={handleChange} value={usuario.nombre} />
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Correo</Label>
                                <Input bsSize="sm" name="correo" onChange={handleChange} value={usuario.correo} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Telefono</Label>
                                <Input bsSize="sm" name="telefono" onChange={handleChange} value={usuario.telefono} />
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Rol</Label>
                                <Input bsSize="sm" type={"select"} name="idRol" onChange={handleChange} value={usuario.idRol} className="form-control" >
                                    <option value={0}>Seleccionar</option>
                                    {
                                        roles.map((item) => (<option key={item.idRol} value={item.idRol}>{item.descripcion}</option>))
                                    }

                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="4" >
                            <FormGroup>
                                <Label>Contraseña</Label>
                                <Input bsSize="sm" name="clave" onChange={handleChange} value={usuario.clave} type="password" />
                            </FormGroup>
                        </Col>
                        <Col sm="4" >
                            <FormGroup>
                                <Label>DGII</Label>
                                <Input bsSize="sm" name="dgii" onChange={handleChange} value={usuario.dgii}  />
                            </FormGroup>
                        </Col>

                        <Col sm="4" >
                        <FormGroup>
                            <Label>Empresa </Label>

                                <Input bsSize="sm" type={"select"} name="empresaID" onChange={handleChange} value={usuario.empresaID} className="form-control">
                                    <option value={new Number(0)}>Seleccionar Una Opcion</option>
                                    {ListaEmpr.map(x =>
                                        <option key={x.empresaID} value={x.empresaID} >{x.descripcion}</option>
                                )}
                            </Input>

                        </FormGroup>
                            </Col>
                        <Col sm="4" >
                            <FormGroup>
                                <Label>Print Punto Venta</Label>
                                <Input bsSize="sm" type={"select"} name="impresionPuntoVenta" onChange={handleChange} value={usuario.impresionPuntoVenta} className="form-control">
                                    <option value={false}>No </option>
                                    <option value={true}>Si</option>
                                    
                                </Input>
                            </FormGroup>
                        </Col><Col sm="4" >
                            <FormGroup>
                                <Label>Estado</Label>
                                <Input bsSize="sm" type={"select"} name="esActivo" onChange={handleChange} value={usuario.esActivo} className="form-control">
                                    <option value={true}>Activo</option>
                                    <option value={false}>No Activo</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    
                   
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary" onClick={guardarCambios}>Guardar</Button>
                    <Button size="sm" color="danger" onClick={cerrarModal}>Cerrar</Button>
                </ModalFooter>
            </Modal>

            <Modal isOpen={verModal}>
                <ModalHeader style={{ backgroundColor: '#4e73df', color: "white", borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }} toggle={cerrarModal}>
                    Detalle Usuario
                </ModalHeader>
                <ModalBody>

                    <h6 className="text-primary">Información del Usuario</h6>
                    <Row>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Nombre completo</Label>
                                <Input bsSize="sm" name="nombre" onChange={handleChange} value={usuario.nombre} placeholder="Ej: Juan Pérez" />
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup>
                                <Label>Correo electrónico</Label>
                                <Input bsSize="sm" type="email" name="correo" onChange={handleChange} value={usuario.correo} placeholder="ejemplo@correo.com" />
                            </FormGroup>
                        </Col>

                        <Row>
                            <Col sm={6}>
                                <FormGroup>
                                    <Label>Telefono</Label>
                                    <Input bsSize="sm" name="telefono" onChange={handleChange} value={usuario.telefono} />
                                </FormGroup>
                            </Col>



                            <Col sm="6" >
                                <FormGroup>
                                    <Label>Empresa </Label>

                                    <Input bsSize="sm" type={"select"} name="empresaID" onChange={handleChange} value={usuario.empresaID} className="form-control">
                                        <option value={new Number(0)}>Seleccionar Una Opcion</option>
                                        {ListaEmpr.map(x =>
                                            <option key={x.empresaID} value={x.empresaID} >{x.descripcion}</option>
                                        )}
                                    </Input>

                                </FormGroup>
                            </Col>
                        </Row>

                        <h6 className="text-primary mt-3">Datos de Acceso</h6>
                        <Row>
                            <Col sm={6}>
                                <FormGroup>
                                    <Label>Contraseña</Label>
                                    <Input bsSize="sm" name="clave" type="password" onChange={handleChange} value={usuario.clave} />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup>
                                    <Label>Rol de usuario</Label>
                                    <Input bsSize="sm" type="select" name="idRol" onChange={handleChange} value={usuario.idRol}>
                                        <option value={0}>Seleccionar</option>
                                        {roles.map((item) => (
                                            <option key={item.idRol} value={item.idRol}>{item.descripcion}</option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>

                        </Row>

                        <Col sm="6" >
                            <FormGroup>
                                <Label>Print Punto Venta</Label>
                                <Input bsSize="sm" type={"select"} name="impresionPuntoVenta" onChange={handleChange} value={usuario.impresionPuntoVenta} className="form-control">
                                    <option value={false}>No </option>
                                    <option value={true}>Si</option>

                                </Input>
                            </FormGroup>
                        </Col><Col sm="6" >
                            <FormGroup>
                                <Label>Estado</Label>
                                <Input bsSize="sm" type={"select"} name="esActivo" onChange={handleChange} value={usuario.esActivo} className="form-control">
                                    <option value={true}>Activo</option>
                                    <option value={false}>No Activo</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>


                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary" onClick={guardarCambios}>Guardar</Button>
                    <Button size="sm" color="danger" onClick={cerrarModal}>Cerrar</Button>
                </ModalFooter>
            </Modal>


            {/*ASIGNAR PERMISO DE MODULOS A USUARIO*/}

            <Modal isOpen={verModalModulosA} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <h6> <b>   Asignando Modulos al usuario:  {usuario.nombre}</b></h6>
                </ModalHeader>
                <ModalBody>

                    <AsignacionModulos data={[usuario]} d={D_usuarioID} />


                </ModalBody>
                <ModalFooter>

                    <Button size="sm" color="danger"
                        onClick={() => setverModalModulosA(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

        </>
    )
}

export default Usuario;